export const checkinName = () => {
  return 'check-in';
};
